<template><div class="product-promo"></div></template>
<script>
export default {
  name: "ProductPromo"
};
</script>
